import { Brain, Building2, Palette, Zap, type LucideIcon } from 'lucide-react'

export interface Persona {
  id: 'archie' | 'dochie' | 'jobs' | 'vangogh'
  name: string
  role: string
  color: string
  icon: LucideIcon
  produces: string
  /** Especialidade de diagrama no Studio (espelha backend/app/studio/specialists.py). */
  studio: string
}

export const PERSONAS: Persona[] = [
  { id: 'archie', name: 'Archie', role: 'Arquiteto de Soluções', color: '#8b5cf6', icon: Building2, produces: 'Consolida o SDD e marca os ADRs que precisam de decisão humana.', studio: 'Arquitetura de software: C4 (contexto, contêineres, componentes) e integrações' },
  { id: 'dochie', name: 'Dochie', role: 'Analista Multidimensional', color: '#10b981', icon: Brain, produces: 'Revisa tecnologia, risco, inovação e sustentabilidade em paralelo.', studio: 'Dados e segurança: modelo de dados, classes, fluxo de dados e ameaças' },
  { id: 'jobs', name: 'Jobs', role: 'Especialista em Event Storming', color: '#f59e0b', icon: Zap, produces: 'Desenha o Event Storm: eventos, comandos, agregados e hotspots.', studio: 'Processos: fluxogramas, sequência, estados, jornadas e Event Storming' },
  { id: 'vangogh', name: 'Van Gogh', role: 'Visualizador de Arquitetura', color: '#f43f5e', icon: Palette, produces: 'Escolhe os diagramas e o protótipo que contam a história do SDD.', studio: 'Nuvem e infraestrutura: AWS, GCP, Azure, Kubernetes, e o acabamento visual' },
]

export function personaById(id: string): Persona | undefined {
  return PERSONAS.find((p) => p.id === id)
}
